import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetUser } from '../../store/reducers/user';  
import { useWallet } from "@solana/wallet-adapter-react";


const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { disconnect } = useWallet();

    useEffect(() => {
        const logout = () => {
            dispatch(resetUser());
            // Call disconnect() if it's defined in your context
            disconnect(); // Ensure this function is defined/imported
            // setIsLoggedIn(false); // Ensure setIsLoggedIn is defined, possibly through context or props
             navigate("/");
        };

        logout(); // Automatically call logout when the component mounts
    }, [dispatch, navigate]);

    return (
        <>
            <h1>Logging Out...</h1>
        </>
    );
};

export default Logout;
;



